"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyScheduleModel = void 0;
const helpers_1 = require("../helpers");
const types_1 = require("../types");
const CommonScheduleModel_1 = require("./CommonScheduleModel");
class MonthlyScheduleModel extends CommonScheduleModel_1.CommonScheduleModel {
    constructor(initialValue) {
        super(initialValue);
        this.isOnDay = () => {
            return this.getValue().fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay;
        };
        this.isThirdRowScheduleConfigured = () => {
            var _a;
            return helpers_1.isAnyScheduleUnitConfigured(((_a = this.getValue().rows.third) === null || _a === void 0 ? void 0 : _a.schedule) || []);
        };
    }
}
exports.MonthlyScheduleModel = MonthlyScheduleModel;
//# sourceMappingURL=MonthlyScheduleModel.js.map